var path = 'src/app/forms/fields/confirm-password-field.html';
var html = "<input frm-model frm-required equal-to-validator=password ng-required=required() ng-model=model type=password class=form-control /> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/confirm-password-field.html
 ** module id = 259
 ** module chunks = 0
 **/